"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheLongevityFrontier() {
  const {
    ref: headlineRef,
    isVisible: isHeadlineVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: isCtaVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="235160" id="hero-principal" className="bg-background text-foreground relative min-h-screen flex flex-col overflow-hidden selection:bg-primary selection:text-primary-foreground">
      <div className="flex-grow grid grid-cols-1 lg:grid-cols-12">
        {}
        <div className="col-span-1 lg:col-span-7 flex flex-col justify-center px-6 sm:px-12 lg:px-20 xl:px-32 py-32 lg:py-0 z-10 relative">
          <div className="max-w-3xl">
            <h1 ref={headlineRef} className="font-serif text-3xl leading-[1.05] font-bold tracking-tight transition-all duration-1000 ease-out opacity-100 translate-y-0 !text-[rgba(171,158,110,1)] w-full md:text-7xl lg:text-[4.5rem]"><span className="italic text-primary" data-ast-id="f:/src/pages/Home/sections/TheLongevityFrontier.tsx|sig:igp671" data-ast-start="1278" data-ast-end="1831" contenteditable="false" style={{}}><font color="#f2f2f3" data-ast-id="f:/src/pages/Home/sections/TheLongevityFrontier.tsx|sig:wftdxp" data-ast-start="1435" data-ast-end="1787"><span data-ast-id="f:/src/pages/Home/sections/TheLongevityFrontier.tsx|sig:ihrxbs" data-ast-start="1576" data-ast-end="1780" style={{
                  fontStyle: 'normal'
                }}><br /></span></font>Longevidade Profissional e
              <br />Reposicionamento 50+<br /></span><br /></h1>
            
            <p ref={textRef} className={`font-default text-xl md:text-2xl text-muted-foreground mt-8 max-w-2xl leading-relaxed font-normal transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>Posicionamento • Perspectiva • Protagonismo<br /><br />Conexões estratégicas, desenvolvimento executivo e novas oportunidades para profissionais experientes e líderes corporativos.</p>

            <div ref={ctaRef} className={`mt-12 flex flex-wrap gap-4 transition-all duration-1000 delay-400 ease-out ${isCtaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <Button variant="default" size="lg" className="rounded-sm bg-gradient-to-r from-primary to-primary/80 text-primary-foreground border-none hover:opacity-90 tracking-[0.1em] uppercase text-xs font-semibold h-14 px-10 transition-all duration-500 shadow-lg" asChild>
                <Link to="https://wa.me/5511966187866" newTab>Conectar-se à MASTERPRO+</Link>
              </Button>
              <Button variant="ghost" size="lg" className="rounded-sm border border-foreground/10 hover:bg-foreground/5 tracking-[0.1em] uppercase text-xs h-14 px-10 transition-all duration-500" asChild>
                <Link to="https://wa.me/5511966187866" newTab>Falar com um Consultor</Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <div className="col-span-1 lg:col-span-5 relative h-[60vh] lg:h-auto overflow-hidden bg-muted">
          {}
          <div className="absolute inset-0 bg-background/60 mix-blend-multiply z-10 pointer-events-none"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent lg:bg-gradient-to-l lg:from-transparent lg:to-background z-10 pointer-events-none"></div>
          
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/executive_boardroom_skyline.png" alt="Modern boardroom overlooking a city skyline" className="absolute inset-0 w-full h-full object-cover object-center filter grayscale contrast-125 saturate-0 scale-105 animate-[pulse_10s_ease-in-out_infinite_alternate] !text-[rgba(242,242,243,0.97)] !opacity-[1] !border-1 border-[rgba(242,242,243,0.93)] !border-none" style={{
          animationDuration: '20s'
        }} src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/lucid-origin_Ultra-realistic_advisory_board_meeting_with_senior_executives_and_experienced_fe-0.webp" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/lucid-origin_Ultra-realistic_group_of_senior_female_executives_aged_45_to_70_gathered_around_-0.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/lucid-origin_Ultra-realistic_advisory_board_meeting_composed_primarily_of_senior_female_execu-0.webp" />
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-4 z-20 pointer-events-none">
        <span className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground font-mono">
          Scroll to Explore
        </span>
        <div className="w-[1px] h-16 bg-primary/30 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1/3 bg-primary animate-bounce"></div>
        </div>
      </div>
    </section>;
}